import { useEffect } from 'react'
import AuthLogic from '../../functions/logic/Auth'
import ConfigToken from '../../functions/services/Configuracion'

const useRefreshToken = () => {
  const refreshToken = async () => {
    try {
      await AuthLogic.refreshTokenLogic()
    } catch (error) {
      console.error('Error refreshing token', error)
    }
  }

  // refesh token dasb
  const refreshSessionTokenDash = async () => {
    try {
      // Recupero en los 
       if(localStorage.getItem("idReporteForToken")){
          await ConfigToken.getTokenBI('',localStorage.getItem("idReporteForToken"))
          console.log('Session token refreshed')
       }else{
          console.log('Erro no se tiene token')
       }
    } catch (error) {
      console.error('Error refreshing session token', error)
    }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      refreshToken()
      refreshSessionTokenDash()

      //Configuracion Intervalo
      // Configurar intervalos
      const intervalAccess = setInterval(refreshToken, 14 * 60 * 1000)
      const intervalSession = setInterval(refreshSessionTokenDash, 14 * 60 * 1000)

      // Limpieza
      return () => {
        clearInterval(intervalAccess)
        clearInterval(intervalSession)
      }
    }, 14 * 60 * 1000)

    return () => clearTimeout(timeout)
  }, [])
}

export default useRefreshToken
